export const H1 = 'H1';
export const H2 = 'H2';
export const H3 = 'H3';
export const P = 'P';
export const SUB = 'SUB';
export const DESCRIPTION = 'DESCRIPTION';
